"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MERCHANT_PROVIDERS = exports.WHITE_LABEL_ORGS = exports.GUARANTEED_RATE = exports.HOMEBRIDGE = exports.SYNERGY_ONE = exports.IMPROVEMENT_FUNDING = exports.PELLA = exports.PETERSENDEAN = exports.HOMEPOINT = exports.CALIBER = exports.FIGURE = void 0;
var FIGURE = 'figure';
exports.FIGURE = FIGURE;
var CALIBER = 'caliber';
exports.CALIBER = CALIBER;
var HOMEPOINT = 'homepoint';
exports.HOMEPOINT = HOMEPOINT;
var PETERSENDEAN = 'petersendean';
exports.PETERSENDEAN = PETERSENDEAN;
var PELLA = 'pella';
exports.PELLA = PELLA;
var IMPROVEMENT_FUNDING = 'ifunding';
exports.IMPROVEMENT_FUNDING = IMPROVEMENT_FUNDING;
var SYNERGY_ONE = 'synergyone';
exports.SYNERGY_ONE = SYNERGY_ONE;
var HOMEBRIDGE = 'homebridge';
exports.HOMEBRIDGE = HOMEBRIDGE;
var GUARANTEED_RATE = 'apply.rate'; // their own url

exports.GUARANTEED_RATE = GUARANTEED_RATE;
var WHITE_LABEL_ORGS = [CALIBER, HOMEPOINT, SYNERGY_ONE, HOMEBRIDGE, GUARANTEED_RATE];
exports.WHITE_LABEL_ORGS = WHITE_LABEL_ORGS;
var MERCHANT_PROVIDERS = [PETERSENDEAN, PELLA, IMPROVEMENT_FUNDING];
exports.MERCHANT_PROVIDERS = MERCHANT_PROVIDERS;